"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/SentWithBonjoroBadge/index.tsx
var SentWithBonjoroBadge_exports = {};
__export(SentWithBonjoroBadge_exports, {
  SentWithBonjoroBadge: () => SentWithBonjoroBadge,
  SentWithBonjoroBadgeIconPosition: () => SentWithBonjoroBadgeIconPosition,
  SentWithBonjoroBadgeOpacity: () => SentWithBonjoroBadgeOpacity,
  SentWithBonjoroBadgeRounded: () => SentWithBonjoroBadgeRounded,
  SentWithBonjoroBadgeSize: () => SentWithBonjoroBadgeSize,
  SentWithBonjoroBadgeStyle: () => SentWithBonjoroBadgeStyle,
  SentWithBonjoroBadgeTheme: () => SentWithBonjoroBadgeTheme
});
module.exports = __toCommonJS(SentWithBonjoroBadge_exports);
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faArrowRight = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
};

// src/components/SentWithBonjoroBadge/index.tsx
var SentWithBonjoroBadgeStyle = /* @__PURE__ */ ((SentWithBonjoroBadgeStyle2) => {
  SentWithBonjoroBadgeStyle2["Compact"] = "compact";
  SentWithBonjoroBadgeStyle2["Full"] = "full";
  SentWithBonjoroBadgeStyle2["Circle"] = "circle";
  return SentWithBonjoroBadgeStyle2;
})(SentWithBonjoroBadgeStyle || {});
var SentWithBonjoroBadgeSize = /* @__PURE__ */ ((SentWithBonjoroBadgeSize2) => {
  SentWithBonjoroBadgeSize2["ExtraSmall"] = "extra-small";
  SentWithBonjoroBadgeSize2["Small"] = "small";
  SentWithBonjoroBadgeSize2["Medium"] = "medium";
  SentWithBonjoroBadgeSize2["Large"] = "large";
  SentWithBonjoroBadgeSize2["ExtraLarge"] = "extra-large";
  return SentWithBonjoroBadgeSize2;
})(SentWithBonjoroBadgeSize || {});
var SentWithBonjoroBadgeTheme = /* @__PURE__ */ ((SentWithBonjoroBadgeTheme2) => {
  SentWithBonjoroBadgeTheme2["Black"] = "black";
  SentWithBonjoroBadgeTheme2["White"] = "white";
  SentWithBonjoroBadgeTheme2["Yellow"] = "Yellow";
  return SentWithBonjoroBadgeTheme2;
})(SentWithBonjoroBadgeTheme || {});
var SentWithBonjoroBadgeRounded = /* @__PURE__ */ ((SentWithBonjoroBadgeRounded2) => {
  SentWithBonjoroBadgeRounded2["FullAll"] = "full-all";
  SentWithBonjoroBadgeRounded2["TopOnly"] = "top-only";
  SentWithBonjoroBadgeRounded2["TopLeftOnly"] = "top-left-only";
  SentWithBonjoroBadgeRounded2["TopRightOnly"] = "top-right-only";
  SentWithBonjoroBadgeRounded2["BottomOnly"] = "bottom-only";
  SentWithBonjoroBadgeRounded2["BottomLeftOnly"] = "bottom-left-only";
  SentWithBonjoroBadgeRounded2["BottomRightOnly"] = "bottom-right-only";
  SentWithBonjoroBadgeRounded2["All"] = "all";
  return SentWithBonjoroBadgeRounded2;
})(SentWithBonjoroBadgeRounded || {});
var SentWithBonjoroBadgeOpacity = /* @__PURE__ */ ((SentWithBonjoroBadgeOpacity2) => {
  SentWithBonjoroBadgeOpacity2["Low"] = "low";
  SentWithBonjoroBadgeOpacity2["Medium"] = "medium";
  SentWithBonjoroBadgeOpacity2["High"] = "high";
  return SentWithBonjoroBadgeOpacity2;
})(SentWithBonjoroBadgeOpacity || {});
var SentWithBonjoroBadgeIconPosition = /* @__PURE__ */ ((SentWithBonjoroBadgeIconPosition2) => {
  SentWithBonjoroBadgeIconPosition2["Left"] = "left";
  SentWithBonjoroBadgeIconPosition2["Right"] = "right";
  return SentWithBonjoroBadgeIconPosition2;
})(SentWithBonjoroBadgeIconPosition || {});
function SentWithBonjoroBadge({
  iconUrl = "https://static.bonjoro.com/3f5aad223e7a50bbf87ac21ca3ce03cb83659bb1/assets/images/logos/bear-logo.png",
  className,
  iconAndTextContainerClassName,
  iconClassName,
  textContainerClassName,
  sentWithClassName,
  bonjoroClassName,
  arrowContainerClassName,
  arrowClassName,
  onClick,
  url,
  target,
  rel = "noopener noreferrer",
  size = "medium" /* Medium */,
  theme = "black" /* Black */,
  rounded,
  shadow = false,
  opacity,
  style = "compact" /* Compact */,
  iconPosition = "left" /* Left */,
  hideArrow = false,
  cssStyle,
  dimOnHover = false
}) {
  const onClickHandler = (event) => {
    event.stopPropagation();
    onClick == null ? void 0 : onClick();
  };
  const isCompact = style === "compact" /* Compact */;
  const isFull = style === "full" /* Full */;
  const isCircle = style === "circle" /* Circle */;
  const sizeClass = {
    ["extra-small" /* ExtraSmall */]: "",
    ["small" /* Small */]: "",
    ["medium" /* Medium */]: "",
    ["large" /* Large */]: "",
    ["extra-large" /* ExtraLarge */]: ""
  };
  const iconAndTextContainerCompactWithArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pl-1.5 v2-py-1 v2-gap-1",
    ["small" /* Small */]: "v2-pl-2 v2-py-1 v2-gap-1",
    ["medium" /* Medium */]: "v2-pl-2.5 v2-py-2 v2-gap-1",
    ["large" /* Large */]: "v2-pl-3 v2-py-2 v2-gap-1.5",
    ["extra-large" /* ExtraLarge */]: "v2-pl-3.5 v2-py-2.5 v2-gap-2"
  };
  const iconAndTextContainerCompactWithoutArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-px-1.5 v2-py-1 v2-gap-1",
    ["small" /* Small */]: "v2-px-2 v2-py-1 v2-gap-1",
    ["medium" /* Medium */]: "v2-px-2.5 v2-py-2 v2-gap-1",
    ["large" /* Large */]: "v2-px-3 v2-py-2 v2-gap-1.5",
    ["extra-large" /* ExtraLarge */]: "v2-px-3.5 v2-py-2.5 v2-gap-2"
  };
  const iconAndTextContainerFullWithArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pl-3 v2-py-2 v2-gap-2",
    ["small" /* Small */]: "v2-pl-4 v2-py-2 v2-gap-2.5",
    ["medium" /* Medium */]: "v2-pl-5 v2-py-2.5 v2-gap-3",
    ["large" /* Large */]: "v2-pl-[22px] v2-py-2.5 v2-gap-3.5",
    ["extra-large" /* ExtraLarge */]: "v2-pl-6 v2-py-2.5 v2-gap-4"
  };
  const iconAndTextContainerFullWithoutArrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-px-3 v2-py-2 v2-gap-2",
    ["small" /* Small */]: "v2-px-4 v2-py-2 v2-gap-2.5",
    ["medium" /* Medium */]: "v2-px-5 v2-py-2.5 v2-gap-3",
    ["large" /* Large */]: "v2-px-[22px] v2-py-2.5 v2-gap-3.5",
    ["extra-large" /* ExtraLarge */]: "v2-px-6 v2-py-2.5 v2-gap-4"
  };
  const iconAndTextContainerCircleClass = {
    ["extra-small" /* ExtraSmall */]: "v2-p-1 v2-gap-1",
    ["small" /* Small */]: "v2-p-1 v2-gap-1",
    ["medium" /* Medium */]: "v2-p-1 v2-gap-1",
    ["large" /* Large */]: "v2-p-1 v2-gap-1.5",
    ["extra-large" /* ExtraLarge */]: "v2-p-1 v2-gap-2"
  };
  const computeIconAndTextContainerClass = () => {
    if (isCircle) {
      return iconAndTextContainerCircleClass[size];
    }
    return isFull ? hideArrow ? iconAndTextContainerFullWithoutArrowClass[size] : iconAndTextContainerFullWithArrowClass[size] : hideArrow ? iconAndTextContainerCompactWithoutArrowClass[size] : iconAndTextContainerCompactWithArrowClass[size];
  };
  const iconClass = {
    ["extra-small" /* ExtraSmall */]: "v2-w-4 v2-h-4",
    ["small" /* Small */]: "v2-w-5 v2-h-5",
    ["medium" /* Medium */]: "v2-w-6 v2-h-6",
    ["large" /* Large */]: "v2-w-7 v2-h-7",
    ["extra-large" /* ExtraLarge */]: "v2-w-8 v2-h-8"
  };
  const sentWithFullClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xs",
    ["small" /* Small */]: "v2-text-sm",
    ["medium" /* Medium */]: "v2-text-base",
    ["large" /* Large */]: "v2-text-lg",
    ["extra-large" /* ExtraLarge */]: "v2-text-xl"
  };
  const sentWithCompactClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xxs v2-mb-px v2-leading-none",
    ["small" /* Small */]: "v2-text-xxs v2-mb-px v2-leading-tight",
    ["medium" /* Medium */]: "v2-text-xxs",
    ["large" /* Large */]: "v2-text-xs",
    ["extra-large" /* ExtraLarge */]: "v2-text-sm"
  };
  const bonjoroFullClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xs",
    ["small" /* Small */]: "v2-text-sm",
    ["medium" /* Medium */]: "v2-text-base",
    ["large" /* Large */]: "v2-text-lg",
    ["extra-large" /* ExtraLarge */]: "v2-text-xl"
  };
  const bonjoroCompactClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-xs",
    ["small" /* Small */]: "v2-text-sm",
    ["medium" /* Medium */]: "v2-text-base",
    ["large" /* Large */]: "v2-text-lg",
    ["extra-large" /* ExtraLarge */]: "v2-text-xl"
  };
  const arrowContainerFullClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pr-3 v2-py-1 v2-ml-1 v2-pl-0.5",
    ["small" /* Small */]: "v2-pr-3.5 v2-py-1 v2-ml-1 v2-pl-1.5",
    ["medium" /* Medium */]: "v2-pr-4 v2-py-1.5 v2-ml-1 v2-pl-2",
    ["large" /* Large */]: "v2-pr-4 v2-py-2 v2-ml-1.5 v2-pl-2.5",
    ["extra-large" /* ExtraLarge */]: "v2-pr-5 v2-py-2.5 v2-ml-2 v2-pl-3"
  };
  const arrowContainerCompactClass = {
    ["extra-small" /* ExtraSmall */]: "v2-pr-1.5 v2-py-1 v2-ml-1 v2-pl-0.5",
    ["small" /* Small */]: "v2-pr-2 v2-py-1 v2-ml-1 v2-pl-1",
    ["medium" /* Medium */]: "v2-pr-2.5 v2-py-1.5 v2-ml-1 v2-pl-1",
    ["large" /* Large */]: "v2-pr-3 v2-py-2 v2-ml-1.5 v2-pl-2",
    ["extra-large" /* ExtraLarge */]: "v2-pr-3.5 v2-py-2.5 v2-ml-2 v2-pl-2"
  };
  const arrowClass = {
    ["extra-small" /* ExtraSmall */]: "v2-text-sm",
    ["small" /* Small */]: "v2-text-base",
    ["medium" /* Medium */]: "v2-text-xl",
    ["large" /* Large */]: "v2-text-2xl",
    ["extra-large" /* ExtraLarge */]: "v2-text-3xl"
  };
  const themeClass = {
    ["black" /* Black */]: "v2-bg-black",
    ["white" /* White */]: "v2-bg-white v2-drop-shadow",
    ["Yellow" /* Yellow */]: "v2-bg-yellow-500"
  };
  const opacityClass = {
    ["low" /* Low */]: "v2-bg-opacity-25",
    ["medium" /* Medium */]: "v2-bg-opacity-50",
    ["high" /* High */]: "v2-bg-opacity-75",
    "": ""
  };
  const roundedClass = {
    ["full-all" /* FullAll */]: "v2-rounded-full",
    ["top-only" /* TopOnly */]: "v2-rounded-t-md",
    ["bottom-only" /* BottomOnly */]: "v2-rounded-b-md",
    ["all" /* All */]: "v2-rounded-md",
    ["top-left-only" /* TopLeftOnly */]: "v2-rounded-tl-md",
    ["top-right-only" /* TopRightOnly */]: "v2-rounded-tr-md",
    ["bottom-left-only" /* BottomLeftOnly */]: "v2-rounded-bl-md",
    ["bottom-right-only" /* BottomRightOnly */]: "v2-rounded-br-md",
    "": ""
  };
  const arrowContainerRoundedClass = {
    ["full-all" /* FullAll */]: "",
    ["top-only" /* TopOnly */]: "v2-rounded-tr-md",
    ["bottom-only" /* BottomOnly */]: "v2-rounded-br-md",
    ["all" /* All */]: "v2-rounded-r-md",
    ["top-right-only" /* TopRightOnly */]: "v2-rounded-tr-md",
    ["top-left-only" /* TopLeftOnly */]: "",
    ["bottom-right-only" /* BottomRightOnly */]: "v2-rounded-br-md",
    ["bottom-left-only" /* BottomLeftOnly */]: "",
    "": ""
  };
  const dimOnHoverClass = "v2-opacity-50 group-hover/main:v2-opacity-100 v2-transition-all v2-duration-200";
  const iconComponent = /* @__PURE__ */ import_react.default.createElement(
    "img",
    {
      src: iconUrl,
      alt: "Bonjoro Logo",
      className: (0, import_classnames.default)(
        iconClassName,
        iconClass[size],
        "v2-p-0 v2-m-0 v2-select-none"
      )
    }
  );
  return /* @__PURE__ */ import_react.default.createElement(
    "a",
    {
      className: (0, import_classnames.default)(className, [
        "v2-inline-flex v2-cursor-pointer v2-group/main",
        sizeClass[size],
        themeClass[theme],
        roundedClass[rounded != null ? rounded : ""],
        opacityClass[opacity != null ? opacity : ""],
        {
          "v2-drop-shadow hover:v2-drop-shadow-md v2-transition-all v2-duration-200": shadow
        }
      ]),
      href: url,
      target,
      onClick: onClickHandler,
      style: cssStyle,
      rel
    },
    /* @__PURE__ */ import_react.default.createElement(
      "div",
      {
        className: (0, import_classnames.default)(
          iconAndTextContainerClassName,
          computeIconAndTextContainerClass(),
          "v2-flex v2-items-center",
          dimOnHover ? dimOnHoverClass : ""
        )
      },
      iconPosition === "left" /* Left */ && iconComponent,
      !isCircle && /* @__PURE__ */ import_react.default.createElement(
        "div",
        {
          className: (0, import_classnames.default)(
            textContainerClassName,
            "v2-justify-center v2-font-circular v2-select-none",
            {
              "v2-text-white": theme === "black" /* Black */ || theme === "Yellow" /* Yellow */,
              "v2-text-neutral-900": theme === "white" /* White */,
              "v2-flex v2-flex-row v2-justify-center v2-items-center v2-gap-x-2": isFull,
              "v2-flex v2-flex-col v2-justify-center": isCompact
            }
          )
        },
        /* @__PURE__ */ import_react.default.createElement(
          "div",
          {
            className: (0, import_classnames.default)(
              sentWithClassName,
              isFull ? sentWithFullClass[size] : sentWithCompactClass[size],
              "v2-font-circular v2-leading-none v2-p-0 v2-m-0 v2-select-none",
              {
                "[word-spacing:2px]": isFull
              }
            )
          },
          "Sent with"
        ),
        /* @__PURE__ */ import_react.default.createElement(
          "div",
          {
            className: (0, import_classnames.default)(
              bonjoroClassName,
              isFull ? bonjoroFullClass[size] : bonjoroCompactClass[size],
              "v2-font-circular v2-text-base v2-font-semibold v2-tracking-wide",
              "v2-leading-none v2-p-0 v2-m-0 v2-select-none"
            )
          },
          "bonjoro"
        )
      ),
      iconPosition === "right" /* Right */ && iconComponent
    ),
    !hideArrow && !isCircle && /* @__PURE__ */ import_react.default.createElement(
      "div",
      {
        className: (0, import_classnames.default)(
          arrowContainerClassName,
          isFull ? arrowContainerFullClass[size] : arrowContainerCompactClass[size],
          arrowContainerRoundedClass[rounded != null ? rounded : ""],
          "v2-flex v2-items-center ",
          {
            "v2-bg-yellow-500": theme === "white" /* White */
          }
        )
      },
      /* @__PURE__ */ import_react.default.createElement(
        import_react_fontawesome.FontAwesomeIcon,
        {
          className: (0, import_classnames.default)(
            arrowClassName,
            arrowClass[size],
            "group-hover/main:v2-translate-x-1 v2-transition-transform v2-duration-200 v2-select-none",
            {
              "v2-text-yellow-500": theme === "black" /* Black */,
              "v2-text-yellow-700": theme === "white" /* White */ || theme === "Yellow" /* Yellow */
            }
          ),
          icon: faArrowRight
        }
      )
    )
  );
}
